import { FaPalette, FaGlobeAmericas, FaBriefcase, FaBell, FaUserShield } from "react-icons/fa";

export const SETTINGS_SECTIONS = [
  { id: "appearance", label: "Appearance", icon: FaPalette },
  { id: "regional", label: "Regional & Language", icon: FaGlobeAmericas },
  { id: "work-preferences", label: "Work Preferences", icon: FaBriefcase },
  { id: "notifications", label: "Notifications", icon: FaBell },
  { id: "privacy", label: "Privacy", icon: FaUserShield },
];

const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function SettingsNav({ activeId }) {
  return (
    <nav className="bg-surface rounded-xl border border-border shadow-sm p-2">
      {SETTINGS_SECTIONS.map(({ id, label, icon: Icon }) => {
        const active = activeId === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => scrollToSection(id)}
            className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-left text-sm font-medium transition-colors ${
              active ? "bg-primary/[0.09] text-primary" : "text-text_secondary hover:bg-surface_alt"
            }`}
          >
            <Icon size={13} className="shrink-0" />
            <span className="truncate">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
